'use client'
import Loader from '@/components/atoms/Loader'
import { showUIAlert, useSubmitForm } from '@/components/atoms/forms/FormUtils'
import { RequestedFormsConfigType, useMergeFormsConfig } from '@/components/atoms/forms/InputConfigs'
import { useRouter, useSearchParams } from 'next/navigation'
import { HTMLAttributes, useEffect } from 'react'
import BaseFormStyled from '../elements/BaseFormStyled'
import FormBody from '../elements/FormBody'
import { recoverPassword } from '@/services/AuthService'

interface Props extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

const PasswordRecovery = ({ className, ...props }: Props) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const baseFormInputConfigurations: RequestedFormsConfigType = [
    {
      name: 'email',
      className: 'flex-1 text-sm',
      label: 'Email',
      placeholder: 'Email'
    }
  ]
  const inputConfiguration = useMergeFormsConfig(baseFormInputConfigurations)

  const handleForgotPassword = async ({ email }: Record<string, string>) => {
    try {
      await recoverPassword(email)
      router.push('/auth/password-token-reset')
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error)
      console.error('Error during user confirmation:', errorMessage)
      throw error
    }
  }

  const { handleSubmit, isLoading } = useSubmitForm({
    service: handleForgotPassword,
    aditionalPayloadData: {},
    onErrorCallback: () => {
      showUIAlert({
        title: 'Error',
        titleText: 'Usuario o contraseña incorrectos'
      })
    },
    onSuccessCallback: () => {
      console.log('Success')
    }
  })

  const message = isLoading ? 'Cargando...' : 'Enviar'
  useEffect(() => {
    const error = searchParams.get('error')
    if (error) {
      showUIAlert({
        title: 'Error',
        titleText: 'Usuario o contraseña incorrectos'
      })
    }
  }, [])
  return (
    <div className={className} {...props}>
      {isLoading && <Loader />}
      <FormBody className="flex flex-col">
        <BaseFormStyled
          className="flex-1"
          InputsConfig={inputConfiguration}
          onSubmit={handleSubmit}
          submitText={message}
          submitClassName="text-lg w-full"
          cancelMessage="Cancelar"
          onCancel={() => {
            router.push('/')
          }}
        />
      </FormBody>
    </div>
  )
}

export default PasswordRecovery
